module.exports = __webpack_public_path__ + "assets/media/video02.a1516b94.mp4";